import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PaymentReturnPage } from '@/features/billing/return-page';

// Only Build's own attempt id is read; whatever the provider appends is ignored.
const searchSchema = z.object({
  attempt: z.string().uuid().optional().catch(undefined),
  cancelled: z.coerce.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/billing/return')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  return (
    <PaymentReturnPage attemptId={search.attempt ?? ''} cancelled={Boolean(search.cancelled)} />
  );
}
